module.exports = __webpack_public_path__ + "static/partner-gnt-c4bb6b85bd34c26ab27f4d5fa60f9d58.png";